
import {  useQuery } from "react-query"
import DataService from '../../config/DataServices'

const { getRequest} = DataService()





export const useGetHompagedata = ({language }) => {
    return useQuery({
        queryKey: ["home-page",language],
        queryFn: () => {
            return getRequest(`get_homepage?language=${language}`)
        }
    })
}


export const useGetTokonomiesdata = () => {
    return useQuery({
        queryKey: ["home-page-token"],
        queryFn: () => {
            return getRequest("tokenomics")
        }
    })
}


export const useGetFaqdata = () => {
    return useQuery({
        queryKey: ["home-page-faq"],
        queryFn: () => {
            return getRequest("faq")
        }
    })
}




export const useGetpresaletimer = () => {
    return useQuery({
        queryKey: ["presale-timer"],
        queryFn: () => {
            return getRequest("getpresaletimer")
        }
    })
}


export const useGethowitworks = () => {
    return useQuery({
        queryKey: ["gethowitworks"],
        queryFn: () => {
            return getRequest("user/gethowitworks")
        }
    })
}



